import { Card, Col, Tabs, TabsProps } from "antd";
// import TabCheckList from "./TabCheckList";
import TabDetails from "./TabDetails";
import TabActivity from "./TabActivity";
import { getContractDetailType } from "../../../ducks/types";
import TabCheckList from "./TabCheckList";

interface PropsType {
  sidebarData: getContractDetailType | null;
}

export default function RightSideBar(props: PropsType) {
  const { sidebarData } = props;
  const RightSideBarTabs: TabsProps["items"] = [
    {
      key: "1",
      label: "Details",
      children: <TabDetails sidebarData={sidebarData} />,
    },
    {
      key: "2",
      label: "Checklist",
      children: <TabCheckList />,
    },
    {
      key: "3",
      label: "Activity",
      children: <TabActivity />,
    },
  ];

  return (
    <Col flex="360px">
      <Card className="right_inner" style={{ backgroundColor: "transparent" }}>
        <div className="tabsBox">
          <Tabs
            defaultActiveKey="1"
            items={RightSideBarTabs}
            className="dashboard_tabs_cs"
          />
        </div>
      </Card>
    </Col>
  );
}
